// Narrows a supplier's docs to the invoices that are FULLY PAID and dated within
// the selected month — powers the מעקב תשלומים drill-down, which shows only the
// paid invoices of the filtered month.
//
// Fully paid, not merely "has a payment row": the card above this list counts
// fully-settled docs (fullyPaid in server/lib/amountOwed.js), so admitting a
// part-paid document here would make the drill-down list three invoices under a
// card that says two.
//
// docDate is 'DD/MM/YYYY'; dateFrom/dateTo are 'YYYY-MM-DD' (either may be
// empty, meaning "unbounded on that side"). The range comparison itself lives
// in utils/dateFormat.js, shared with the link modal's period filter.

import { ymdKey, isDateInRange } from './dateFormat';

export function paidDocsInMonth(docs, dateFrom, dateTo) {
  return (docs || []).filter((d) => {
    // payment_fully_paid comes from the same SQL predicate the server counts
    // with. The payment_date fallback keeps any caller that hasn't been given
    // the newer field working exactly as before.
    const paid = d.payment_fully_paid != null ? !!d.payment_fully_paid : !!d.payment_date;
    if (!paid) return false;                // unpaid or part-paid — excluded
    // Undated docs are excluded HERE, not by isDateInRange (which admits them
    // on purpose): this drill-down places each document in a specific month,
    // and a doc with no date belongs to none.
    if (!ymdKey(d.date)) return false;
    return isDateInRange(d.date, dateFrom, dateTo);
  });
}
